import { EMPTY_LIST, EMPTY_OBJECT } from '../constants/common'
import {
  DOC_FLOW_RESULT_STATUS_FILTER_CONFIG,
  DocFlowRequestLinksField,
  DocFlowRequestLinksServerError,
} from '../constants/docFlow'
import { ROUTE_UI_SECTION_NAME } from '../constants/route'

import { getSectionCanCreatePermission } from './common'

// A rejected request is full itself, unless the list is longer than one doc flow takes.
function getDocFlowRequestLinksLimitErrorText({ connectedRequests, meta, t }) {
  const limit = meta?.max_size

  const rejectedRequests = connectedRequests.filter(({ value }) =>
    meta?.request_ids?.includes(value)
  )

  if (rejectedRequests.length === 0 || connectedRequests.length > limit) {
    return t('Error.DocFlowRequestLinksLimitExceededKey', { limit })
  }

  return t('Error.RequestDocFlowLinksLimitExceededKey', {
    limit,
    requests: rejectedRequests.map(({ label }) => label).join(', '),
  })
}

export function hasDocFlowsSectionCreatePermission(sections) {
  return getSectionCanCreatePermission(sections, ROUTE_UI_SECTION_NAME.docFlows)
}

export function getDocFlowResultStatusFilterOption({ name, value }) {
  const { statuses, statusIds } = DOC_FLOW_RESULT_STATUS_FILTER_CONFIG[name]

  return { statuses, statusId: statusIds[value] }
}

export function getDocFlowRequestsPayload(requestIds) {
  return { [DocFlowRequestLinksField.DocFlowRequestIds]: requestIds }
}

export function getRequestDocFlowsPayload(docFlowIds) {
  return { [DocFlowRequestLinksField.RequestDocFlowIds]: docFlowIds }
}

// The connect endpoints and the doc flow creation answer 400 with `errors` as a plain key;
// `meta.max_size` carries the limit and `meta.request_ids` the requests that did not fit.
export function getDocFlowRequestLinksErrorText({
  connectedRequests = EMPTY_LIST,
  data,
  t,
}) {
  const { errors, meta } = data ?? EMPTY_OBJECT

  switch (errors) {
    case DocFlowRequestLinksServerError.AlreadyConnected:
      return t('Error.DocFlowRequestAlreadyConnectedKey')
    case DocFlowRequestLinksServerError.LimitExceeded:
      return getDocFlowRequestLinksLimitErrorText({
        connectedRequests,
        meta,
        t,
      })
    default:
      return null
  }
}

export function getDocFlowRequestLinksErrorNotification({ error, t }) {
  return {
    title:
      getDocFlowRequestLinksErrorText({ data: error?.response?.data, t }) ??
      t('Error.CommonApiRequestFailKey'),
  }
}
